// extracted by mini-css-extract-plugin
export default {"row":"editMatches_row__OlJUq","col":"editMatches_col__MsSXg","card":"editMatches_card__Knbwz"};